"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by david.petrosyan on 10/09/18.
 */
var core_1 = require("@angular/core");
require("rxjs/add/observable/from");
require("rxjs/add/observable/of");
require("rxjs/add/operator/catch");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
var Observable_1 = require("rxjs/Observable");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var entity_helper_service_1 = require("./entity-helper.service");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var http_1 = require("@angular/common/http");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var entity_model_1 = require("../../model/entity.model");
var operators_1 = require("rxjs/operators");
var entity_helper_new_service_1 = require("./entity-helper-new.service");
var HttpEntitySearchService = /** @class */ (function () {
    function HttpEntitySearchService(_applicationPropertiesService, _kbService, _languageService, _classifierService, _http, _currentLanguageProvider) {
        this._applicationPropertiesService = _applicationPropertiesService;
        this._kbService = _kbService;
        this._languageService = _languageService;
        this._classifierService = _classifierService;
        this._http = _http;
        this._currentLanguageProvider = _currentLanguageProvider;
        this.ENTITY_SEARCH_SERVICE_URI_KEY = 'entity-search-service-url';
        this.URL_LOAD_ENTITY_ITEMS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/entities/"], ["", "/entities/"])), 'serviceUri');
        this.URL_LOAD_ENTITY_ITEMS_WITH_EXTERNAL_FILTERS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/portfolio/entities/"], ["", "/portfolio/entities/"])), 'serviceUri');
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_http);
        this._entitySearchHelperService = new entity_helper_service_1.EntitySearchHelperService(_kbService, _languageService, _classifierService, this);
        this._entitySearchHelperNewService = new entity_helper_new_service_1.EntitySearchHelperNewService(_kbService, _languageService, _classifierService, this);
    }
    HttpEntitySearchService_1 = HttpEntitySearchService;
    HttpEntitySearchService.prototype.loadEntitySearchItems = function (systemName, filterFields, multilingualFields, nameFieldIds, categoryIdentityFieldSystemName, languageId, paging, sorting, filter, categoryPermissionTypes, kbPrefix) {
        var _this = this;
        if (categoryPermissionTypes === void 0) { categoryPermissionTypes = [idm_um_permission_client_js_1.CategoryPermissionType.VIEW]; }
        idm_common_util_frontend_1.PreconditionCheck.notNull(systemName);
        var entitySearchServiceUrl$ = Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ENTITY_SEARCH_SERVICE_URI_KEY));
        return entitySearchServiceUrl$.mergeMap(function (serviceUri) {
            var url = _this.URL_LOAD_ENTITY_ITEMS.replaceTemplate({ serviceUri: serviceUri });
            var entityModel = _this.getEntityModel(systemName, categoryPermissionTypes, paging, sorting, kbPrefix);
            entityModel.filter = encodeURIComponent(JSON.stringify(filter.toJson() || {}));
            var entitySearchItemsData$ = _this.load(url, entityModel);
            return _this._entitySearchHelperService.extractEntitySearchItems(entitySearchItemsData$, filterFields, multilingualFields, nameFieldIds, languageId, categoryIdentityFieldSystemName);
        });
    };
    HttpEntitySearchService.prototype.loadPortfolioItems = function (systemName, paging, sorting, filters, categoryPermissionTypes, compoundMainEntityFields, expressionFilters, kbPrefix) {
        var _this = this;
        if (categoryPermissionTypes === void 0) { categoryPermissionTypes = [idm_um_permission_client_js_1.CategoryPermissionType.VIEW]; }
        idm_common_util_frontend_1.PreconditionCheck.notNull(systemName);
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ENTITY_SEARCH_SERVICE_URI_KEY))
            .mergeMap(function (serviceUri) {
            var url = _this.URL_LOAD_ENTITY_ITEMS.replaceTemplate({ serviceUri: serviceUri });
            var portfolioDataObservable = _this._currentLanguageProvider.getCurrentLanguage()
                .mergeMap(function (language) {
                var entityModel = _this.getEntityModel(systemName, categoryPermissionTypes, paging, sorting, kbPrefix);
                entityModel.filter = encodeURIComponent(JSON.stringify(filters || {}));
                return _this.load(url, entityModel);
            });
            return _this._entitySearchHelperService.deserializeEntities(systemName, portfolioDataObservable, compoundMainEntityFields, categoryPermissionTypes);
        });
    };
    HttpEntitySearchService.prototype.loadPortfolioItemsByFields = function (systemName, paging, sorting, filters, expressionFilters, categoryPermissionTypes, fieldsToLoad, kbPrefix) {
        var _this = this;
        if (categoryPermissionTypes === void 0) { categoryPermissionTypes = [idm_um_permission_client_js_1.CategoryPermissionType.VIEW]; }
        idm_common_util_frontend_1.PreconditionCheck.notNull(systemName);
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ENTITY_SEARCH_SERVICE_URI_KEY))
            .pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_LOAD_ENTITY_ITEMS_WITH_EXTERNAL_FILTERS.replaceTemplate({ serviceUri: serviceUri });
            var entityModel = new entity_model_1.EntityModel();
            entityModel.category = systemName;
            if (paging !== undefined && paging !== null) {
                entityModel.paging = paging;
            }
            if (sorting !== undefined && sorting !== null) {
                entityModel.sortFields = (_a = {}, _a[sorting.sortField] = sorting.sortType === idm_de_core_frontend_1.SortType.ASC ? 'ASC' : 'DESC', _a);
            }
            if (fieldsToLoad && fieldsToLoad.length > 0) {
                entityModel.fields = fieldsToLoad;
            }
            if (kbPrefix !== undefined && kbPrefix !== null) {
                entityModel.kbPrefix = kbPrefix;
            }
            if (categoryPermissionTypes !== undefined &&
                categoryPermissionTypes !== null &&
                categoryPermissionTypes.length !== 0) {
                entityModel.categoryPermissionTypes =
                    categoryPermissionTypes.map(function (categoryPermissionType) { return idm_um_permission_client_js_1.CategoryPermissionType[categoryPermissionType]; });
            }
            entityModel.filter = filters || {};
            entityModel.externalFilter = expressionFilters || {};
            return _this._entitySearchHelperService.deserializeEntitiesNew(systemName, _this.load(url, entityModel), fieldsToLoad, categoryPermissionTypes);
            var _a;
        }));
    };
    HttpEntitySearchService.prototype.loadPortfolioItemsByFields2 = function (systemName, paging, sorting, filters, expressionFilters, categoryPermissionTypes, fieldsToLoad, kbPrefix) {
        var _this = this;
        if (categoryPermissionTypes === void 0) { categoryPermissionTypes = [idm_um_permission_client_js_1.CategoryPermissionType.VIEW]; }
        idm_common_util_frontend_1.PreconditionCheck.notNull(systemName);
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ENTITY_SEARCH_SERVICE_URI_KEY))
            .pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_LOAD_ENTITY_ITEMS_WITH_EXTERNAL_FILTERS.replaceTemplate({ serviceUri: serviceUri });
            var entityModel = _this.constructEntityModel(systemName, paging, sorting, fieldsToLoad ? fieldsToLoad.get(systemName) : undefined, categoryPermissionTypes, filters, expressionFilters, kbPrefix);
            return _this._entitySearchHelperNewService.deserializeEntities(systemName, _this.load(url, entityModel), fieldsToLoad, categoryPermissionTypes, kbPrefix);
        }));
    };
    HttpEntitySearchService.prototype.constructEntityModel = function (systemName, paging, sorting, fieldsToLoad, categoryPermissionTypes, filters, expressionFilters, kbPrefix) {
        var entityModel = new entity_model_1.EntityModel();
        entityModel.category = systemName;
        if (paging !== undefined && paging !== null) {
            entityModel.paging = paging;
        }
        if (kbPrefix !== undefined && kbPrefix !== null) {
            entityModel.kbPrefix = kbPrefix;
        }
        if (sorting !== undefined && sorting !== null) {
            entityModel.sortFields = (_a = {}, _a[sorting.sortField] = sorting.sortType === idm_de_core_frontend_1.SortType.ASC ? 'ASC' : 'DESC', _a);
        }
        if (fieldsToLoad && fieldsToLoad.length > 0) {
            entityModel.fields = fieldsToLoad;
        }
        if (categoryPermissionTypes !== undefined &&
            categoryPermissionTypes !== null &&
            categoryPermissionTypes.length !== 0) {
            entityModel.categoryPermissionTypes =
                categoryPermissionTypes.map(function (categoryPermissionType) { return idm_um_permission_client_js_1.CategoryPermissionType[categoryPermissionType]; });
        }
        entityModel.filter = filters || {};
        entityModel.externalFilter = expressionFilters || {};
        return entityModel;
        var _a;
    };
    HttpEntitySearchService.prototype.loadEntityItemsByFields = function (systemName, paging, sorting, filters, categoryPermissionTypes, fields, expressionFilters, kbPrefix) {
        var _this = this;
        if (categoryPermissionTypes === void 0) { categoryPermissionTypes = [idm_um_permission_client_js_1.CategoryPermissionType.VIEW]; }
        idm_common_util_frontend_1.PreconditionCheck.notNull(systemName);
        return Observable_1.Observable.from(this._applicationPropertiesService.getProperty(this.ENTITY_SEARCH_SERVICE_URI_KEY))
            .mergeMap(function (serviceUri) {
            var url = _this.URL_LOAD_ENTITY_ITEMS.replaceTemplate({ serviceUri: serviceUri });
            var entityModel = _this.getEntityModel(systemName, categoryPermissionTypes, paging, sorting, kbPrefix);
            if (fields) {
                entityModel.fields = fields;
            }
            entityModel.filter = encodeURIComponent(JSON.stringify(filters || {}));
            return _this.load(url, entityModel);
        });
    };
    HttpEntitySearchService.prototype.loadEntityFieldIds = function (systemName, fieldName, paging, sorting, filters, categoryPermissionTypes, expressionFilters, kbPrefix) {
        if (categoryPermissionTypes === void 0) { categoryPermissionTypes = [idm_um_permission_client_js_1.CategoryPermissionType.VIEW]; }
        return this.loadEntityItemsByFields(systemName, paging, sorting, filters, categoryPermissionTypes, [fieldName], expressionFilters, kbPrefix).map(function (entityData) {
            var ids = new Set();
            entityData.data.forEach(function (item) {
                if (Array.isArray(item[fieldName])) {
                    item[fieldName].forEach(function (item) {
                        if (item) {
                            ids.add(item);
                        }
                    });
                }
                else {
                    if (item[fieldName]) {
                        ids.add(item[fieldName]);
                    }
                }
            });
            return Array.from(ids);
        });
    };
    ;
    HttpEntitySearchService.prototype.load = function (url, entityModel) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(url);
        var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
        var options = { headers: headers };
        return this._http
            .post(url, entityModel, options)
            .map(HttpEntitySearchService_1.extractResponseData)
            .catch(HttpEntitySearchService_1.handleResponseError);
    };
    HttpEntitySearchService.prototype.getEntityModel = function (systemName, categoryPermissionTypes, paging, sorting, kbPrefix) {
        var entityModel = new entity_model_1.EntityModel();
        entityModel.category = systemName;
        if (categoryPermissionTypes !== undefined &&
            categoryPermissionTypes !== null &&
            categoryPermissionTypes.length !== 0) {
            var categoryPermissionTypeNames = categoryPermissionTypes.map(function (categoryPermissionType) { return idm_um_permission_client_js_1.CategoryPermissionType[categoryPermissionType]; });
            entityModel.categoryPermissionTypes = categoryPermissionTypeNames.toString();
        }
        if (paging !== undefined && paging !== null) {
            entityModel.paging = paging;
        }
        if (sorting !== undefined && sorting !== null) {
            entityModel.sortFields = (_a = {}, _a[sorting.sortField] = sorting.sortType === idm_de_core_frontend_1.SortType.ASC ? 'ASC' : 'DESC', _a);
        }
        if (kbPrefix !== undefined && kbPrefix !== null) {
            entityModel.kbPrefix = kbPrefix;
        }
        return entityModel;
        var _a;
    };
    HttpEntitySearchService.extractResponseData = function (body) {
        return body || {};
    };
    HttpEntitySearchService.handleResponseError = function (error) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(error);
        var message = error.error instanceof ErrorEvent
            ? "An error occurred: " + error.error.message
            : error;
        return Observable_1.Observable.throw(message);
    };
    HttpEntitySearchService = HttpEntitySearchService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService, idm_kb_service_client_js_1.KbService, idm_message_language_service_client_js_1.LanguageService, idm_classifier_service_client_js_1.ClassifierService,
            idm_authentication_client_js_1.HttpClientWrapper, idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], HttpEntitySearchService);
    return HttpEntitySearchService;
    var HttpEntitySearchService_1;
}());
exports.HttpEntitySearchService = HttpEntitySearchService;
var templateObject_1, templateObject_2;
//# sourceMappingURL=http-entity.service.js.map